import { api } from './axios'

// 客户案例-数据配置
export const getBuyInfoCommon = (params) => {
  //zxcerptest.cpsol.net/cartonfactory/activity/getBuyInfoCommon.do
  return api({
    method: 'post',
    url: '/cartonfactory/activity/getBuyInfoCommon.do',
    data: params
  })
}
